export default __webpack_public_path__ + "static/media/diamond.6e0751ae.svg";